import request from '../../utils/Request';
import { Methods } from '../../config';
import { downloadFile } from '../../utils/download';
import dayjs from 'dayjs';

const baseURL = 'attendanceSettlement';

const attendanceSettlementService = {
  getData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  getExcelData: async (attendanceSettlementId) => {
    const excelFromServer = await request({
      responseType: 'blob',
      resource: `${baseURL}/data/export/${encodeURIComponent(attendanceSettlementId)}`,
    });
    return downloadFile(excelFromServer, `Elszámolások-${dayjs().format('YYYYMMDD_HHmm')}.xlsx`);
  },

  deleteData: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};
export default attendanceSettlementService;
